module.exports = __webpack_public_path__ + "static/media/boy-7.ff92c030.svg";